<template>
  <div>
    <Row type="flex" class="tai-xiu-history-specific-total-row">
      <Col class="tai-xiu-history-specific-total-row-col">
        <Row type="flex" class="tai-xiu-history-specific-total-table-title-row">
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("general.sum")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o104")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o105")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o106")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o107")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o108")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o109")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o110")
            }}
          </Col>
        </Row>
        <Row type="flex">
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("general.gap")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-4">
            {{
            gap_st_4
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-5">
            {{
            gap_st_5
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-6">
            {{
            gap_st_6
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-7">
            {{
            gap_st_7
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-8">
            {{
            gap_st_8
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-9">
            {{
            gap_st_9
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-10">
            {{
            gap_st_10
            }}
          </Col>
        </Row>
      </Col>
    </Row>
    <Row type="flex" class="tai-xiu-history-specific-total-row">
      <Col class="tai-xiu-history-specific-total-row-col">
        <Row type="flex" class="tai-xiu-history-specific-total-table-title-row">
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("general.sum")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o111")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o112")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o113")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o114")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o115")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o116")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("tai_xiu.o117")
            }}
          </Col>
        </Row>
        <Row type="flex">
          <Col class="tai-xiu-history-specific-total-table-title">
            {{
            $t("general.gap")
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-11">
            {{
            gap_st_11
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-12">
            {{
            gap_st_12
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-13">
            {{
            gap_st_13
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-14">
            {{
            gap_st_14
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-15">
            {{
            gap_st_15
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-16">
            {{
            gap_st_16
            }}
          </Col>
          <Col class="tai-xiu-history-specific-total-table-cell cell-17">
            {{
            gap_st_17
            }}
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { size, reduce, pickBy, toArray, reverse, forEach } from "lodash";
import { TweenLite, TimelineLite } from "gsap";
//import "gsap/TextPlugin.js";

export default {
  props: ["stat", "gameId"],
  components: {
    Row,
    Col
  },
  data() {
    return {
      remappedHistoricalData: [],
      numberAnimationCountdown: 1.5,
      gap_st_4: 0,
      gap_st_5: 0,
      gap_st_6: 0,
      gap_st_7: 0,
      gap_st_8: 0,
      gap_st_9: 0,
      gap_st_10: 0,
      gap_st_11: 0,
      gap_st_12: 0,
      gap_st_13: 0,
      gap_st_14: 0,
      gap_st_15: 0,
      gap_st_16: 0,
      gap_st_17: 0
    };
  },
  computed: {
    trimHistoricalData() {
      let last18Cols = pickBy(this.remappedHistoricalData, function(
        item,
        index
      ) {
        return index < 18;
      });

      TweenLite.fromTo(
        ".tai-xiu-history-trend-lot-col",
        0.5,
        {
          opacity: 0
        },
        {
          opacity: 1
        }
      );

      return reverse(toArray(last18Cols));
    }
  },
  watch: {
    historicalData() {
      TweenLite.fromTo(
        ".tai-xiu-history-trend-lot-col",
        0.5,
        {
          opacity: 1
        },
        {
          opacity: 0
        }
      );

      this.remappedHistoricalData = reduce(
        this.historicalData,
        (acc, cur) => {
          if (parseInt(cur.triple)) {
            cur.win = this.$t("tai_xiu.o3_trend");
          } else if (parseInt(cur.bs) === 1) {
            cur.win = this.$t("tai_xiu.o1_trend");
          } else {
            cur.win = this.$t("tai_xiu.o2_trend");
          }

          // If it is the first item, create new index
          if (!size(acc)) {
            return {
              ...acc,
              [size(acc)]: (acc[size(acc)] || []).concat(cur)
            };
          } else {
            let lastObjectArray = acc[size(acc) - 1] || [];
            let lastArrayItem = size(lastObjectArray)
              ? lastObjectArray[size(lastObjectArray) - 1]
              : {};
            let lastItemWin = lastArrayItem.win;

            if (lastItemWin === cur.win) {
              return {
                ...acc,
                [size(acc) - 1]: (acc[size(acc) - 1] || []).concat(cur)
              };
            } else {
              return {
                ...acc,
                [size(acc)]: (acc[size(acc)] || []).concat(cur)
              };
            }
          }
        },
        {}
      );
    },
    stat() {
      let vm = this;

      let gapObj = pickBy(this.stat, (item, key) => key.match(/^gap/gi));

      forEach(gapObj, (item, key) => {
        this.animateGapNumber(key);
      });
    }
  },
  methods: {
    animateGapNumber(statTargerNumber) {
      let vm = this;
      let counter = { val: 0 };

      let animationTl = new TimelineLite();

      TweenLite.to(counter, this.numberAnimationCountdown, {
        val: this.stat[statTargerNumber],
        roundProps: "val",
        onUpdate: function() {
          vm[statTargerNumber] = counter.val;
        }
      });

      animationTl
        .to(
          "#game-" +
            this.gameId +
            " .tai-xiu-history-specific-total-table-cell",
          0.5,
          {
            delay: this.numberAnimationCountdown,
            "text-shadow": "0 0 10px #d73f68"
          }
        )
        .to(
          "#game-" +
            this.gameId +
            " .tai-xiu-history-specific-total-table-cell",
          0.5,
          {
            "text-shadow": "none"
          }
        );

      animationTl.restart();
    }
  }
};
</script>

<style lang="scss" scoped>
.tai-xiu-history-specific-total-row {
  margin: 20px 5px;
}
.tai-xiu-history-specific-total-table-title {
  flex: 1;
  background-color: $tai-xiu-theme-color-12;
  text-align: center;
  color: $tai-xiu-theme-color-4;
  font-weight: bold;
  border-right: 1px solid rgba($tai-xiu-theme-color-3, 10%);
  padding: 2px 0;
  font-size: 12px;
}

.tai-xiu-history-specific-total-table-title:first-of-type {
  flex: 2;
}

.tai-xiu-history-specific-total-table-cell {
  flex: 1;
  background-color: rgba($tai-xiu-theme-color-5, 20%);
  text-align: center;
  color: $tai-xiu-theme-color-4;
  border-right: 1px solid rgba($tai-xiu-theme-color-3, 10%);
  padding: 2px 0;
  font-size: 12px;
}

.tai-xiu-history-specific-total-table-title:last-of-type,
.tai-xiu-history-specific-total-table-cell:last-of-type {
  border-right: unset;
}

.tai-xiu-history-specific-total-row-col {
  width: 100%;
}

.tai-xiu-history-specific-total-table-title-row {
  border-bottom: 1px solid rgba($tai-xiu-theme-color-3, 10%);
}
</style>
